import {createStrokeSVG} from './TEMPLATE'

// tabler: circle-arrow-up
export const ArrowTopCircle_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0',
    'M12 8l-4 4',
    'M12 8v8',
    'M16 12l-4 -4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
